import { render, staticRenderFns } from "./Trimax.vue?vue&type=template&id=d019497e&scoped=true"
import script from "./Trimax.vue?vue&type=script&lang=js"
export * from "./Trimax.vue?vue&type=script&lang=js"
import style0 from "./Trimax.vue?vue&type=style&index=0&id=d019497e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d019497e",
  null
  
)

export default component.exports